import React, { useState, useEffect } from "react";
import { Container, Button } from "react-bootstrap";
import { List } from "react-bootstrap-icons";
import Navi from "./Navi";
import "./MainLayout.css"

const MainLayout = ({ children }) => {
  const [meniuRestrans, setMeniuRestrans] = useState(false);
  const [tema, setTema] = useState(localStorage.getItem("tema") || "light");

  const toggleMeniu = () => setMeniuRestrans(!meniuRestrans);

  const toggleTema = () => {
    const nouaTema = tema === "light" ? "dark" : "light";
    setTema(nouaTema);
    localStorage.setItem("tema", nouaTema);
  };

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", tema);

    if (tema === "dark") {
      document.body.classList.add("bg-dark", "text-light");
    } else {
      document.body.classList.remove("bg-dark", "text-light");
    }
  }, [tema]);

  return (
    <Container fluid className="layout-container">
      <div className="layout-row">
        <div
          className={`layout-sidebar ${
            meniuRestrans ? "layout-sidebar-restrans" : ""
          }`}
        >
          <div
            className={`layout-sidebar-header ${
              meniuRestrans
                ? "justify-content-center"
                : "justify-content-between"
            }`}
          >
            {!meniuRestrans && (
              <h4 className="layout-title">SITUAȚIA EXPLOATĂRII</h4>
            )}

            <Button
              variant={tema === "dark" ? "outline-info" : "outline-success"}
              onClick={toggleMeniu}
              className="layout-toggle-button"
            >
              <List size={22} />
            </Button>
          </div>

          <div className="layout-nav-container">
            <Navi
              tema={tema}
              toggleTema={toggleTema}
              restrans={meniuRestrans}
            />
          </div>
        </div>

        <div className="layout-main">
          {typeof children === "function" ? children(tema) : children}
        </div>
      </div>
    </Container>
  );
};

export default MainLayout;
